import { useSelector } from 'react-redux';
import { useAccount } from 'wagmi';
import { IDexTrade, Network } from '@kattana-io/common';
import TradesTable from './Table';
import TradesTableMobile from './TableMobile';
import { IStore } from '../../../reducers';

export interface ITradesSelector {
  loading: boolean;
  exchange: string;
  flipped: boolean;
  trades: IDexTrade[];
  base: string;
  quote: string;
  quote_decimals: number;
  txUrl: string;
  address: string | undefined;
  chain: string;
  walletUrl: string;
}

const selector = (state: IStore): ITradesSelector => {
  const [base, quote] = state.current.name.split('/');
  return {
    exchange: state.current.exchange,
    flipped: state.current.flipped,
    loading: state.dex_trades.loading,
    trades: state.dex_trades.trades,
    base,
    quote,
    address: state.current.address,
    quote_decimals: state.current.quote_decimals,
    chain: state.current.chain,
    txUrl: Network.fromChain(state.current.chain)?.getScan() || '',
    walletUrl: Network.fromChain(state.current.chain)?.getScanForWallet() || '',
  };
};

export interface ITradesDataLayerProps {
  width?: number;
  isMobile?: boolean;
}

const TradesDataLayer = ({ width, isMobile }: ITradesDataLayerProps) => {
  const state = useSelector(selector);
  const { address } = useAccount();

  const openTx = (tx: string) => window.open(`${state.txUrl}${tx}`);

  const openWallet = (wallet: string) =>
    window.open(`${state.walletUrl}${wallet}`);

  return isMobile ? (
    <TradesTableMobile {...state} openWallet={openWallet} />
  ) : (
    <TradesTable
      {...state}
      currentWallet={address}
      width={width}
      openTx={openTx}
      openWallet={openWallet}
    />
  );
};

export default TradesDataLayer;
